import reducer from "./reducer";
export { default as IssueAbsences } from "./components";
export { default as issueAbsencesReducerName } from "./constants";
export default reducer;
